import "./enlacesInformativos.css";

const SoporteTecnico = () => {
  return (
    <div className="informacion mx-auto border-0 w-[100%] md:w-[80%] min-h-screen py-[30px] lg:px-0 px-[20px]">
        <h1>Soporte Técnico para Anfitriones</h1>
        <p>
          Para facilitar la gestión de los alojamientos, ofrecemos un soporte
          técnico para resolver cualquier inconveniente con la plataforma.
        </p>

        <h2>1. Preguntas Frecuentes</h2>
        <p>
          Antes de contactar al soporte, revisa nuestra sección de Preguntas
          Frecuentes:
        </p>
        <ul>
          <li>🔹 No puedo acceder a mi cuenta.</li>
          <li>🔹 Cómo editar mi anuncio.</li>
          <li>🔹 Cómo cambiar mis precios o disponibilidad.</li>
          <li>🔹 Cómo responder a un mensaje de un huésped.</li>
        </ul>
        <p>
          <a href="/preguntas-frecuentes">
            Ver todas las preguntas frecuentes → Acceso a FAQ
          </a>
        </p>

        <h2>2. Canal de Contacto Directo</h2>
        <p>
          Si necesitas asistencia personalizada, puedes contactarnos a través de
          los siguientes medios:
        </p>
        <ul>
          <li>
            📞 Teléfono: <a href="tel:+5493516837321">+54 9 351 683 7321</a>{" "}
            (Horario de atención: 9:00 a 20:00 hs)
          </li>
          <li>
            💬 WhatsApp:{" "}
            <a href="http://wa.me/5493516837321">Enviar mensaje por WhatsApp</a>
          </li>
          <li>
            📧 Email:{" "}
            <a href="mailto:rumbo.punilla@gmail.com">rumbo.punilla@gmail.com</a>
          </li>
        </ul>
        <p>
          <strong>Tiempo estimado de respuesta:</strong> 24 horas hábiles.
        </p>

        <h2>3. Problemas con la Plataforma</h2>
        <p>
          Si experimentas errores técnicos, puedes probar lo siguiente antes de
          contactarnos:
        </p>
        <ul>
          <li>
            📌 <strong>¿No puedes cargar fotos?</strong> Verifica que el formato
            sea JPG o PNG y que no supere los 5MB.
          </li>
          <li>
            📌 <strong>¿No puedes acceder a tu cuenta?</strong> Prueba
            restablecer la contraseña o borra caché y cookies del navegador.
          </li>
          <li>
            📌 <strong>¿Tu anuncio no aparece en las búsquedas?</strong>{" "}
            Asegúrate de que la disponibilidad y ubicación estén bien
            configuradas.
          </li>
        </ul>
        <p>
          Si el problema persiste, envíanos un reporte detallado con capturas de
          pantalla a nuestro{" "}
          <a href="mailto:rumbo.punilla@gmail.com">email de soporte</a>.
        </p>
    </div>
  );
};

export default SoporteTecnico;
